let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5B1VR")).then(() => parcelRequire('jdBzR'));